import React from 'react';
import { Modal } from 'react-bootstrap';
import {
  getQuestStockCount,
  isQuestActive
} from 'containers/WStorePage/WStoreUtils';
import CloseIcon from 'resources/X_close_icon.png';
import PurpleW from 'resources/PurpleW.png';
import SapphireIcon from 'resources/icons-currency-sapphire-sml.png';
import WScoreIcon from 'resources/ui-icon-wscore.png';
import WStoreConfirmationNew from '../WStoreConfirmationNew';
import './WStoreQuestRedeemModal.css';

const WStoreQuestRedeemModal = ({
  selectedItem,
  hidden,
  onClose,
  purchaseConfirmation,
  onPurchase,
  purchaseRequested
}) => {
  const renderMissions = () => {
    const missions = selectedItem.prizeData.questAwardData.quest.achievements;
    const missionList = missions.map((mission, index) => {
      return (
        <div key={index} className="mission">
          <div className="mission-title">
            <span className="mission-number">{index + 1}.</span>
            {mission.description}:
          </div>
          <div className="mission-task">
            {' '}
            {mission.progressPlaceholderText}{' '}
          </div>
        </div>
      );
    });

    return <div className="quest-missions-container">{missionList}</div>;
  };

  const renderTotalCost = () => (
    <div className="total-cost-container">
      <div className="total-cost">Total cost: </div>
      <div className="wscore-info">
        <img src={WScoreIcon} alt="WScore" />
        <div className="wscore-cost">{`WScore: ${selectedItem.wscore}`}</div>
        {selectedItem.sapphireCost && (
          <>
            <div className="cost-separator">+</div>
            <img src={SapphireIcon} alt="Sapphire" />
            <div>{`Sapphires: ${selectedItem.sapphireCost}`}</div>
          </>
        )}
      </div>
    </div>
  );

  const renderRedeemButton = () => {
    const disabled =
      isQuestActive(selectedItem) ||
      getQuestStockCount(selectedItem) <= 0 ||
      purchaseRequested;
    const buttonClass = `redeem-button${disabled ? '-disabled' : ''}`;

    return (
      <button
        className={buttonClass}
        type="button"
        onClick={onPurchase}
        disabled={disabled}
      >
        Redeem & Start
      </button>
    );
  };

  const renderValidText = () => {
    const { claimStartDate, claimEndDate, locations } = selectedItem;

    const isValidForOneDay = claimEndDate === claimStartDate;
    const validDates = isValidForOneDay
      ? claimEndDate
      : `${claimStartDate} - ${claimEndDate}`;

    const validText = `Valid only on ${validDates} at `;
    const locationText = locations.includes('All')
      ? 'any Wind Creek Location'
      : `Wind Creek ${locations.join(', ')}`;

    return (
      <div className="valid-location-text">
        *{validText}
        {locationText}
      </div>
    );
  };

  const show = selectedItem && !hidden;

  return (
    show && (
      <Modal
        className={`modal-dialog-wstore-quest-redeem ${
          purchaseConfirmation ? 'modal-overlay' : ''
        }`}
        show={true}
        onHide={onClose}
      >
        <Modal.Body>
          <button className="exit-modal-button" type="button" onClick={onClose}>
            <img src={CloseIcon} alt="Close purchase modal" />
          </button>
          <img
            className="quest-icon"
            src={selectedItem.imageUrl || PurpleW}
            alt={selectedItem.name}
          />
          <div className="quest-title">{selectedItem.name}</div>
          <div className="complete-by">{`Complete by ${selectedItem.claimEndDate}`}</div>
          <div className="quest-description">{selectedItem.description}</div>
          {renderMissions()}
          {renderTotalCost()}
          {renderRedeemButton()}
          {purchaseConfirmation && (
            <WStoreConfirmationNew isQuestItem={true} onClose={onClose} />
          )}
          {renderValidText()}
        </Modal.Body>
      </Modal>
    )
  );
};

export default WStoreQuestRedeemModal;
